module.exports = __webpack_public_path__ + "img/18.3a65155d.png";